// import { AxiosGetSecretApi } from "../../utils/fetchApi";
import {
    GET_AUTH 
} from "./type";

// export const getDataAuth = () => async (dispatch) => {
// //   let res = await AxiosGetSecretApi("/api/users/verifytoken");
// //   console.log(res)
//   dispatch({
//     type: GET_AUTH,
//     payload: true,
//   });
// };

export const getDataAuth = (status) => async (dispatch) => {
    dispatch({
      type: GET_AUTH,
      payload: status,
    });
  };


